var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-octagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22.9999 15.3335V23.0002M22.9999 30.6668H23.0191M3.83325 16.3354V29.6649C3.83325 30.1337 3.83325 30.3681 3.88621 30.5887C3.93316 30.7843 4.0106 30.9712 4.11569 31.1427C4.23422 31.3361 4.39997 31.5019 4.73146 31.8334L14.1667 41.2686C14.4982 41.6001 14.6639 41.7659 14.8574 41.8844C15.0289 41.9895 15.2158 42.0669 15.4114 42.1139C15.632 42.1668 15.8664 42.1668 16.3352 42.1668H29.6647C30.1335 42.1668 30.3679 42.1668 30.5884 42.1139C30.784 42.0669 30.971 41.9895 31.1425 41.8844C31.3359 41.7659 31.5016 41.6001 31.8331 41.2686L41.2684 31.8334C41.5999 31.5019 41.7656 31.3361 41.8841 31.1427C41.9892 30.9712 42.0667 30.7843 42.1136 30.5887C42.1666 30.3681 42.1666 30.1337 42.1666 29.6649V16.3354C42.1666 15.8666 42.1666 15.6322 42.1136 15.4116C42.0667 15.2161 41.9892 15.0291 41.8841 14.8576C41.7656 14.6642 41.5999 14.4984 41.2684 14.167L31.8331 4.7317C31.5016 4.40021 31.3359 4.23447 31.1425 4.11594C30.971 4.01085 30.784 3.93341 30.5884 3.88645C30.3679 3.8335 30.1335 3.8335 29.6647 3.8335H16.3352C15.8664 3.8335 15.632 3.8335 15.4114 3.88645C15.2158 3.93341 15.0289 4.01085 14.8574 4.11594C14.6639 4.23447 14.4982 4.40021 14.1667 4.7317L4.73146 14.167C4.39997 14.4984 4.23422 14.6642 4.11569 14.8576C4.0106 15.0291 3.93316 15.2161 3.88621 15.4116C3.83325 15.6322 3.83325 15.8666 3.83325 16.3354Z",
    stroke: "#EB5757",
    strokeWidth: 3.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOctagon);
export default __webpack_public_path__ + "static/media/alert-octagon.291fb617b8e8d7977ad16127c7c5ad4a.svg";
export { ForwardRef as ReactComponent };